import React, { Fragment, useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Ltp(props) {
  const symbol_id = props.symbol_id;
  const socket = useContext(SocketContext);

  const [LTP, setLtp] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (data != null) {
      if (LTP !== data.LTP) {
        setLtp(data.LTP);
      }
    }
  };

  return <div className="Ltp">{LTP}</div>;
}
